<template>
	<div class="mode-of-transport">
		<div 
			v-for="mode in modes"
			:key="mode.property"
			@click="onClick(mode.property)" 
			class="btn prestep-new-btn transportation"
			:class="{active: active === mode.property && mode.property === 'misc'}"
			:style="active === mode.property && mode.property !== 'misc' ? {'background-color': (mode.color || '#012169') + ' !important', 'border-color': mode.color, 'color': '#fff'} : {}"
		>
			<i v-if="mode.icon" :class="mode.icon"></i>

			{{ mode.title }}
		</div>
	</div>	
</template>

<script>
export default {
	props: ['value'],

	mounted() {
		this.active = this.value
	},

	data() {
		return {
			active: null,

			modes: [
				{title: 'Promenad', property: 'walk', color: '#27A228', icon: 'icon-walking'},
				{title: 'Cykel', property: 'bike', color: '#00a9ce', icon: 'icon-bicycle'},
				{title: 'Kollektivtrafik', property: 'transit', color: '#ff671f', icon: 'icon-train'},
				{title: 'Bil', property: 'car', color: '#2237AF', icon: 'icon-car'},
				{title: 'Annat', property: 'misc', color: null, icon: null}
			]
		}
	},

	methods: {
		onClick(property) {
			this.active = property
			this.$emit('selected', property)
		}
	}
}
</script>